export const AI_CHAT_SUGGESTED_QUESTIONS = [
  'Which supplier has the most delays?',
  "What's my worst lane this month?",
  'Which shipments are in transit?',
  'Show me delivered shipments this week',
];
